import { Space } from "antd";

import { useQuery } from "react-query";
import { getOMReservationInfo } from "../../../../apis/OrderManagement/order";
import useReservation from "../../../../hooks/useReservation";
import color from "../../../../theme/color";
import { CustomDrawer } from "../../Drawer";
import { GhostClose } from "../../Icon";
import { IconForm } from "../../Icon/index.styled";
import { OrderInfoCard } from "./OrderInfo";
import { TabLayoutForm } from "./Tab";
import { Section } from "./index.styled";

interface ReservationDetailDrawerProps {
  id: string | undefined;
  onClose?: () => void;
}

/**
 * 예약현황 상세  - drawer
 * @param param0
 * @returns
 */
export const ReservationDetailDrawer: React.FC<
  ReservationDetailDrawerProps
> = ({ id, onClose = () => void 0 }) => {
  const { reservation, setReservation } = useReservation();

  useQuery(
    ["OM", id, "OrderReservationInfo"],
    () => getOMReservationInfo(id as string),
    {
      enabled: !!id,
      refetchOnMount: "always",
      onSuccess: (data) => {
        const repairInfo = data.rows.find(
          (item) => item.reservationType === "방문정보"
        );

        if (repairInfo) {
          setReservation({
            ...reservation,
            reservedAt: repairInfo.repairReservedAt,
            reservedStatus: repairInfo.reservedStatus,
          });
        }
      },
    }
  );

  return (
    <>
      <CustomDrawer
        title="예약현황"
        open={!!id}
        onClose={onClose}
        closable={false}
        getContainer="#cgInfoRoot"
        push={false}
        extra={
          <IconForm
            component={GhostClose}
            style={{ fontSize: 16 }}
            onClick={onClose}
          />
        }
        destroyOnClose
        bodyStyle={{ padding: 0 }}
      >
        <Space direction="vertical" size={0} style={{ display: "flex" }}>
          <Section style={{ padding: 16, background: color.gray10 }}>
            <OrderInfoCard />
          </Section>
          <TabLayoutForm />
        </Space>
      </CustomDrawer>
    </>
  );
};
